import { HANDLE_ERROR } from '../actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const handleError = (error) => ({
  type: HANDLE_ERROR,
  payload: { error },
});
